/**
 * @see {@link AbstractControl.status}
 * Angular (up to v8) doesn't expose the enum
 * https://github.com/angular/angular/issues/27389
 */
export enum ENgFormStatus {
  Valid = 'VALID',
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Disabled = 'DISABLED',
}
